import { TAppState } from '../../types/appState';

export function chatWindowSelector(state: TAppState) {
  return state.chatWindow;
}
